import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TPatchAccrualBalanceRequestSchema,
  TPatchAccrualBalanceResponseSchema,
} from "./patchAccrualBalance.schema";

export const patchAccrualBalance = (axios: IAxiosInstance) => {
  return async ({
    companyID,
    policy_code,
    employees,
  }: TPatchAccrualBalanceRequestSchema) => {
    const { data } = await axios.noRetry.patch<
      IApiResponse<TPatchAccrualBalanceResponseSchema>
    >("/accrualBalance", {
      companyID,
      policy_code,
      employees,
    });

    if (data.success) {
      return data.data;
    }

    throw new Error("Something went wrong");
  };
};
